// Eerst de bol zelf: deze module neemt straks z'n pauzeer-trigger over.
import './globe-gallery.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

// Zichtbare bol ÷ Osmo-lijstbreedte: de kaarten aan de achterkant zijn
// weggefade, dus de bol oogt ~81% van de lijst. De Figma-maten (en de target)
// zijn de zichtbare bol.
const VISIBLE_RATIO = 0.814;

// Globe op scroll — Figma 3583:7175 → 3583:6999 (Socials Hellema).
//
// De bol zelf is de Osmo 3D sphere carousel uit het globe-gallery block
// (components/blocks/globe-gallery/globe-gallery.js init 'm, deze module raakt
// de draaiing niet aan). Hier alleen de reis: de bol staat groot en
// gecentreerd in het intro-scherm en schaalt tijdens het scrollen naar z'n
// plek rechts naast de tekst ([data-globe-scroll-target]).
function initGlobeScroll( section ) {
	const intro  = section.querySelector( '[data-globe-scroll-intro]' );
	const globe  = section.querySelector( '[data-globe-scroll-globe]' );
	const target = section.querySelector( '[data-globe-scroll-target]' );
	const list   = globe?.querySelector( '[data-3d-carousel-wrap]' );

	if ( ! intro || ! globe || ! target || ! list ) {
		return;
	}

	// Osmo pauzeert de draaiing zodra de lijst uit beeld is, gemeten op de
	// plek van de grote bol. Die reist hier mee naar beneden; meet daarom over
	// de hele sectie (zelfde callbacks, ander bereik).
	const pauseTrigger = ScrollTrigger.getAll().find( ( st ) => st.trigger === list );
	if ( pauseTrigger ) {
		const { onEnter, onEnterBack, onLeave, onLeaveBack } = pauseTrigger.vars;
		pauseTrigger.kill();
		ScrollTrigger.create( {
			trigger: section,
			start: 'top bottom',
			end: 'bottom top',
			onEnter,
			onEnterBack,
			onLeave,
			onLeaveBack,
			invalidateOnRefresh: true,
		} );
	}

	// Verschuiving + schaal van de bol (layout-positie, zonder transform) naar
	// het midden en de breedte van de target.
	const getEnd = () => {
		const sectionRect = section.getBoundingClientRect();
		const targetRect  = target.getBoundingClientRect();

		return {
			x: targetRect.left - sectionRect.left + targetRect.width / 2 - ( globe.offsetLeft + globe.offsetWidth / 2 ),
			y: targetRect.top - sectionRect.top + targetRect.height / 2 - ( globe.offsetTop + globe.offsetHeight / 2 ),
			scale: targetRect.width / ( list.offsetWidth * VISIBLE_RATIO ),
		};
	};

	if ( reduceMotion ) {
		const place = () => gsap.set( globe, getEnd() );
		place();
		window.addEventListener( 'resize', place );
		return;
	}

	gsap.fromTo(
		globe,
		{ x: 0, y: 0, scale: 1 },
		{
			x: () => getEnd().x,
			y: () => getEnd().y,
			scale: () => getEnd().scale,
			ease: 'power1.inOut',
			scrollTrigger: {
				trigger: intro,
				start: 'top top',
				end: 'bottom top',
				scrub: true,
				invalidateOnRefresh: true,
			},
		}
	);
}

function initGlobeScrolls() {
	document.querySelectorAll( '[data-globe-scroll]' ).forEach( initGlobeScroll );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initGlobeScrolls );
} else {
	initGlobeScrolls();
}
